import {combineReducers} from "redux";
import {reducer as formReducer} from "redux-form";
import emp from "./empReducers";
import error from "./errorReducers";
import auth from "./Authentication/authReducers";
import ajaxCallsInProgress from "./ajaxStatusReducer";
import joinees from "./Recruitment/recruitReducer";
import attendance from "./Attendance/attendanceReducer";
import employees from "./Employee/employeeReducers";
import leave from "./leaveReducer";
import employeeDetails from "./Employee/employeeDetailsReducers";
import constants from "./constantReducers";

//defining a root reducer.. mandatory.. as more reducers add up .. combine them here
const rootReducer = combineReducers({
  emp,
  employees,
  employeeDetails,
  error,
  auth,
  ajaxCallsInProgress,
  form: formReducer,
  joinees,
  attendance,
  leave,
  constants
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/index.js
 **/